import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=4f91810e"
import script from "./grant.vue?vue&type=script&lang=ts"
export * from "./grant.vue?vue&type=script&lang=ts"
import style0 from "./grant.vue?vue&type=style&index=0&id=4f91810e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports